"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TokenService = /** @class */ (function () {
    function TokenService(authorization) {
        this.Events = {
            TOKEN_EXPIRE: 'tokenexpire',
            TOKEN_NEW: 'tokennew',
        };
        this.authorization = undefined;
        this.accessToken = null;
        this.authorization = authorization;
    }
    TokenService.prototype.setToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    TokenService.prototype.getToken = function () {
        var _this = this;
        var _a, _b;
        if (this.accessToken &&
            this.authorization &&
            !((_a = this.authorization) === null || _a === void 0 ? void 0 : _a.isTokenActive(this.accessToken))) {
            return (((_b = this.authorization) === null || _b === void 0 ? void 0 : _b.refreshToken().then(function (token) {
                if (token) {
                    _this.setToken(token);
                    return token;
                }
                return _this.accessToken;
            })) || this.accessToken);
        }
        return this.accessToken;
    };
    return TokenService;
}());
exports.default = TokenService;
